// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3x9PG","label":"Category_label__1So1A","content":"Category_content__4_7Jk","header":"Category_header__3v1vJ","location":"Category_location__1X6E6"};